var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-status status-block"},[_c('span',{staticClass:"status",class:_vm.status.class},[_vm._v(" "+_vm._s(_vm.status.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }